<template>
    <div class="row">
        <div class="col s12 m12">
            <md-collection :key="user.name">
                <md-collection-item href="javascript:void(0)">{{ $t("account.personalData.name") }}
                    <md-badge>{{ user.name }} {{ user.firstName }} {{ user.lastName }}</md-badge>
                </md-collection-item>
                <md-collection-item href="javascript:void(0)">{{ $t("account.personalData.username") }}
                    <md-badge class="">{{ user.username }}</md-badge>
                </md-collection-item>
                <md-collection-item href="javascript:void(0)">Tipo
                    <md-badge class="">{{ user.role }}</md-badge>
                </md-collection-item>
                <md-collection-item href="javascript:void(0)">Club
                    <md-badge class="">{{ user.club }}</md-badge>
                </md-collection-item>
                <md-collection-item href="javascript:void(0)">Club1
                    <md-badge class="">{{ user.club1 }}</md-badge>
                </md-collection-item>
                <md-collection-item href="javascript:void(0)">Club2
                    <md-badge class="">{{ user.club2 }}</md-badge>
                </md-collection-item>
                <md-collection-item href="javascript:void(0)">ELO
                    <md-badge class="">{{ user.elo }}</md-badge>
                </md-collection-item>
                <md-collection-item href="javascript:void(0)">Chatear
                    <md-badge class="">{{ user.chattext ? '[x]' : '[ ]'}}</md-badge>
                </md-collection-item>
                <md-collection-item href="javascript:void(0)">Chatear con vídeo
                    <md-badge class="">{{ user.chat ? '[x]' : '[ ]'}}</md-badge>
                </md-collection-item>
                <md-collection-item href="javascript:void(0)">Chatear audio
                    <md-badge class="">{{ user.chataudio ? '[x]' : '[ ]'}}</md-badge>
                </md-collection-item>
                <md-collection-item href="javascript:void(0)">{{$t("game.createClass")}}
                    <md-badge class="">{{ user.cast ? '[x]' : '[ ]'}}</md-badge>
                </md-collection-item>
                <md-collection-item href="javascript:void(0)">{{$t("events.title")}}
                    <md-badge class="">{{ user.live ? '[x]' : '[ ]'}}</md-badge>
                </md-collection-item>
                <md-collection-item href="javascript:void(0)">Analizar
                    <md-badge class="">{{ user.analyse ? '[x]' : '[ ]'}}</md-badge>
                </md-collection-item>
                <md-collection-item href="javascript:void(0)">Enviar análisis
                    <md-badge class="">{{ user.sendtoanalyse ? '[x]' : '[ ]'}}</md-badge>
                </md-collection-item>
                <md-collection-item href="javascript:void(0)">Descargar
                    <md-badge class="">{{ user.download ? '[x]' : '[ ]'}}</md-badge>
                </md-collection-item>
                <md-collection-item href="javascript:void(0)">{{ $t("account.personalData.email") }}
                    <md-badge>{{user.email}}</md-badge>
                </md-collection-item>
                <md-collection-item href="javascript:void(0)">{{ $t("account.personalData.created") }}
                  <md-badge>{{ user.created | moment ('DD/MM/YYYY hh:mm:ss') }}</md-badge>
                </md-collection-item>
                <md-collection-item href="javascript:void(0)">{{ $t("user.login") }}
                  <md-badge>{{ user.login | moment ('DD/MM/YYYY hh:mm:ss') }}</md-badge>
                </md-collection-item>
                <md-collection-item href="javascript:void(0)">{{ $t("user.logout") }}
                  <md-badge>{{ user.logout | moment ('DD/MM/YYYY hh:mm:ss') }}</md-badge>
                </md-collection-item>
                <md-collection-item href="javascript:void(0)">Tiempo de uso
                  <md-badge>{{ formatTime(user.time) }}</md-badge>
                    <!-- <md-badge class="">{{ user.time }}</md-badge>-->
                </md-collection-item>
            </md-collection>
        </div>
    </div>

</template>

<script>
// import Storage from '../../../services/lstorage'
import moment from 'moment'

export default {
  name: 'PersonalData',
  props: {
    user: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  methods: {
    formatTime (seconds) {
      const duration = moment.duration(seconds, 'seconds')
      const months = Math.floor(duration.asMonths())
      const days = duration.days()
      // const hours = duration.hours()
      // const minutes = duration.minutes()
      // const secs = duration.seconds()
      let formattedTime = ''
      if (months > 0) {
        formattedTime += `${months} meses `
      }
      if (days > 0) {
        formattedTime += `${days} días `
      }
      formattedTime += moment.utc(duration.asMilliseconds()).format('HH:mm:ss')
      return formattedTime.trim()
    },
    updateData () {
      this.$forceUpdate()
    },
    imageUrlAlt (event) {
      event.target.src = '../../../static/images/50x50defaultAvatar.png'
    },
    imageUrl (name) {
      // return this.dirServer + '/uploads/' + name
      if (name !== undefined) {
        return this.dirServer + '/uploads/' + name
      } else {
        return
      }
    }
  },
  events: {
  }
}
</script>


// WEBPACK FOOTER //
// personalData.vue?618589e2